// extracted by mini-css-extract-plugin
export default {"TableHeader":"TableHeader_TableHeader__d9CHY","ThemedHeader":"TableHeader_ThemedHeader__wbQxG"};